import {
  AuthResourcesClient,
  HttpClient,
  IAuthenticationPublicWebServiceClient,
  ICampagneWebServiceClient, IParameterWebServiceClient,
  IProfilWebServiceClient,
  IUserTransformationCompteWebServiceClient,
  IUtilisateurWebServiceClient
} from "./resources/auth/resources.auth";
import { AsiToggle } from "./pipe/asiToggle.pipe";
import { AutocompleteFixedDataComponent } from "./components/autocomplete-fixed/autocomplete-fixed.component";
import { VosFiltresPanelComponent } from "./components/filter/vos-filtres-panel/vos-filtres-panel.component";
import { AsiDatePipe } from "./pipe/asi-date.pipe";
import { HighlightPipe} from "./pipe/highlight.pipe";
import {AsiCurrency } from "./pipe/asi-currency.pipe";
import { AsiCaptchaComponent } from "./components/asi-captcha/asi-captcha.component";

import { AsiPrinter } from "./components/printer/printer.component";
import { WaitingModalService } from "./components/modal/waiting/waiting.service";
import { NotificationComponent } from "./components/notification/notification-component/notification.component";
import { NotificationService } from "./components/notification/notification.service";
import { AsiDividerComponent } from "./components/divider/asi-divider.component";
import { CookieModule } from "ngx-cookie";

import { LocalePipe } from "./pipe/locale.pipe";
import { WindowService } from "./services/window.service";
import { CerbaCookieService } from "./services/cerbacookie.service";
import { CerbaAuthService } from "./services/auth.service";
import { CssInjectorService } from "./services/css-injector.service";
import { HeaderResourcesInjectorService } from "./services/header-resources-injector.service";
import { InfoModal } from "./components/modal/info/info.modal";
import { ConfirmModal } from "./components/modal/confirm/confirm.modal";
import { ModalService } from "./components/modal/modal.service";
import { ArianeComponent } from "./components/ariane/ariane.component";
import { ArianeStore } from "./components/ariane/ariane.store";
import { ReCaptchaModule } from "angular2-recaptcha";

import { PopinCompteComponent } from "./components/popin-compte/popin-compte.component";

import { ResourcesClient } from "./resources/auth/resources.client";

import { MomentService } from "./services/moment.service";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";

import { AsiFilterService } from "./components/filter/asi-filter.service";
import { AsiFilterPipe } from "./components/filter/asi.filter.pipe";

import { EnsureUserAuthGuard } from "./guards/security/cerba-security.guard";
import { LogoutAuthGuard } from "./guards/security/cerba-logout.guard";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { RouterModule } from "@angular/router";

import { AsiNgToolsModule } from "@asi-ngtools/lib";

import { FlexLayoutModule } from "@angular/flex-layout";
import { WaitingModal } from "./components/modal/waiting/waiting.modal";
import { AbstractLoadingResolver } from "./services/abstract-loading.resolver";
import { UserAgentCssDirective } from "./components/user-agent/user-agent-css.directive";
import { UserStore } from "./store/user.store";
import { CorrespondantStore } from "./store/correspondant.store";
import {UpdatePasswordModal} from "./components/update-password-modal/update-password-modal";
import {UpdatePasswordComponent} from "./components/update-password/update-password-component";
import {MessageNotificationComponent} from "./components/message-notification/message-notification-component";


const declarations: Array<any> = [WaitingModal, NotificationComponent]

const sharedDeclarations: Array<any> = [
  AsiToggle, AsiCurrency, AsiDividerComponent, ArianeComponent, ConfirmModal, InfoModal, LocalePipe, AsiDatePipe, HighlightPipe, AsiFilterPipe, AsiPrinter,
  VosFiltresPanelComponent, AutocompleteFixedDataComponent, AsiCaptchaComponent, UserAgentCssDirective, PopinCompteComponent,UpdatePasswordModal, UpdatePasswordComponent,
  MessageNotificationComponent
];

/** Liste des composants necessitant la création d'une factory */
var entryComponents: Array<any> = [
  ConfirmModal, InfoModal, WaitingModal, NotificationComponent, PopinCompteComponent,UpdatePasswordModal, UpdatePasswordComponent,MessageNotificationComponent
];

/** Liste des services et exports des class */
const services: Array<any> = [
  MomentService, ModalService, CssInjectorService, HeaderResourcesInjectorService, CerbaCookieService, CerbaAuthService,
  WindowService, ArianeStore, EnsureUserAuthGuard, LogoutAuthGuard, AsiFilterService, WaitingModalService, IParameterWebServiceClient,
  NotificationService, AbstractLoadingResolver, IAuthenticationPublicWebServiceClient, AuthResourcesClient,IUtilisateurWebServiceClient,
  CorrespondantStore, UserStore, ICampagneWebServiceClient, IProfilWebServiceClient,IUserTransformationCompteWebServiceClient, {provide: HttpClient, useClass: ResourcesClient}
];

export * from './components/filter/asi-filter.service';
export * from './services/moment.service';
export * from './services/css-injector.service';
export * from './services/header-resources-injector.service';
export * from './services/window.service';
export * from './services/cerbacookie.service';
export * from './services/auth.service';
export * from './services/abstract-loading.resolver';

export * from './components/modal/waiting/waiting.service';

export * from './components/modal/modal.service';

export * from './resources/correspondant.service';
export * from './resources/userInformation.service';
export * from './guards/security/cerba-security.guard';
export * from './guards/security/cerba-logout.guard';

/** Gestion des filtres */
export * from './components/filter/filters/filter-object';
export * from './components/filter/filters/contains.filter';
export * from './components/filter/filters/boolean.filter';
export * from './components/filter/filters/subproperty-contains.filter';
export * from './components/filter/filters/contains-multiple.filter';
export * from './components/filter/filters/contains-multiple-unified-value.filter';
export * from './components/filter/filters/between-dates.filter';
export * from './components/filter/filters/match-type.filter';
export * from './components/filter/filters/same-id.filter';
export * from './components/filter/filters/types-contrat.filter';
export * from './components/filter/filters/startwith.filter';
export * from './components/filter/filters/tarification.filter';

export * from './components/ariane/ariane.store';
export * from './components/ariane/ariane.resources.provided';
export * from './components/user-agent/user-agent-css.directive';
export * from './constantes/cookie.constantes';
export * from './constantes/tag.constantes';
export * from './store/correspondant.store';
export * from './store/user.store';
export * from './components/notification/notification.service';

export * from './components/popin-compte/popin-compte.component';

export * from './resources/httpOverride.factory';
export * from './resources/httpOverride';

export * from './resources/auth/resources.auth';

export * from './i18n/MultiTranslateHttpLoader';

var sharedModules: Array<any> = [RouterModule,
  FormsModule,
  ReactiveFormsModule,
  FlexLayoutModule,
  ReCaptchaModule];

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    ...sharedModules,
    CookieModule.forRoot(),
    AsiNgToolsModule.forRoot()
  ],
  exports: [AsiNgToolsModule, ...sharedDeclarations, ...sharedModules],
  declarations: [...declarations, ...sharedDeclarations],
  providers: [...services],
  entryComponents: [...entryComponents]
})
export class DigiCerbaCommonModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: DigiCerbaCommonModule,
      providers: [...services]
    };
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/index.ts